import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Download, Edit, KeyboardArrowLeft } from "@mui/icons-material";
import { setupInitialDate } from "../utils/utils";
import { convertArrayToCSV } from "../utils/utils";
import { saveAs } from 'file-saver'; // If you're using file-saver


const CustomerList = ({
  setCurrentTab,
  sheetData,
  loading,
  setSelectedCustomer,
  setShowEditForm,
  setParent
}) => {
  const [filteredSheetData, setFilteredSheetData] = useState(sheetData);

  // Define the custom header order
  const prioritizedHeaders = [
    "Prospect Card No.",
    "Lead Status",
    "Customer Category (based on Present Car1)",
    "Customer Name",
    "Enquiry Type",
    "Gate Pass No.",
    "Sales Consultant",
    "Contact No."
  ];

  const handleSearch = (event) => {
    let searchText = event?.target?.value?.toLowerCase();
    setFilteredSheetData(
      sheetData?.filter((dataItem) => {
        if (
          `${dataItem["Prospect Card No."]}`.includes(searchText) ||
          dataItem["Customer Name"]?.toLowerCase()?.includes(searchText) ||
          dataItem["Sales Consultant"]?.toLowerCase()?.includes(searchText)
        ) {
          return true;
        }
      })
    );
  };
  const handleDownloadCSV = () => {
    const csv = convertArrayToCSV(filteredSheetData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'customer_list.csv'); // Use file-saver to trigger download
  };


  useEffect(()=>{
console.log("AV==FF==>",filteredSheetData);

  },[filteredSheetData])
  
  let maxLength = 20;

  function convertDate(dateString) {
    const [year, month, day] = dateString?.split('-');
    return `${day}/${month}/${year}`;
  }

  // Helper function to rearrange headers based on the custom order
  const arrangeHeaders = (data) => {
    const headers = Object.keys(data[0] || {});
    const prioritized = prioritizedHeaders.filter(header => headers.includes(header));
    const remaining = headers.filter(header => !prioritizedHeaders.includes(header));
    return [...prioritized, ...remaining]; // Prioritized first, then remaining
  };

  return (
    <>
      <Button
        variant="outlined"
        className="navigaton_button"
        onClick={() => {
          setCurrentTab(null);
          setSelectedCustomer({});
          setShowEditForm(false);
        }}
      >
        <KeyboardArrowLeft /> Back to Home
      </Button>
      <Box className="SearchEditBoxWrapper">
       {/* <Stack direction={"row"} justifyContent={"space-between"}> */}
        {/* <Box></Box> */}
        <Typography fullWidth variant="h6" className="section_header">
          SEARCH
        </Typography>
        {/* <Button variant="outlined" onClick={handleDownloadCSV}><Download/></Button> */}
       {/* </Stack> */}
        <Box>
          <Stack fullWidth></Stack>
          <TextField
            fullWidth
            placeholder="Search for Prospect Card No., Customer Name or Consultant Name"
            onChange={handleSearch}
          />
        </Box>
        {loading ? (
          <Box fullWidth className="CustomerDataLoader">
            <CircularProgress />
          </Box>
        ) : filteredSheetData?.length > 0 ? (
          <TableContainer component={Paper} className="CustomerTableContainer">
            <Table>
              <TableHead className="CustomerTableHeader">
                <TableRow>
                  <TableCell></TableCell>
                  {filteredSheetData?.length > 0 &&
                    arrangeHeaders(filteredSheetData)?.map((header) => (
                      <TableCell key={header}>{header}</TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredSheetData?.map((row, index) => (
                  <TableRow
                    key={index}
                    className={index % 2 === 0 ? "" : "CustomerRowStripe"}
                  >
                    <TableCell>
                      <div
                        onClick={() => {
                          // let customerWithNewDate = setupInitialDate(row);
                          setSelectedCustomer(row);
                          setParent("search");
                          setCurrentTab("editCurrent");
                          setTimeout(() => {
                            setShowEditForm(true);
                          }, 1000);
                        }}
                        className="customer_list_edit_wrapper"
                      >
                        <Edit />
                      </div>
                    </TableCell>
                    {arrangeHeaders(sheetData)?.map((header) => (
                      <TableCell
                        className="customer_list_table_cell"
                        key={header}
                      >
                        {((header?.toLowerCase()?.includes("date") || header === "Month") && row[header]?.length > 0)
                          ? convertDate(row[header])
                          : row[header]?.length > maxLength
                          ? row[header]?.substring(0, maxLength) + "..."
                          : row[header]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography className="customer_list_no_data" variant="subtitle1">
            No data found.
          </Typography>
        )}
      </Box>
    </>
  );
};

export default CustomerList;
